<template>
    <div>
        <v-card variant="outlined">
            <v-card-title>Pesquisar Usuário</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="8">
                        <v-text-field label="Usuário aqui..." clearable
                            v-mask="'###-######'"
                            @keyup.enter="FindUserMoodleUNDB({username})"
                            v-model="username">
                            <template v-slot:append>
                                <v-btn @click="FindUserMoodleUNDB({username})"
                                    :loading="StateFoundUserMoodleLoading"
                                    :disabled="StateFoundUserMoodleLoading || (username||'').length < 3">
                                    <v-icon>mdi-magnify</v-icon> &nbsp; Pesquisar
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="StateFoundUserMoodle">
                        <v-card>
                            <v-card-title>
                                {{StateFoundUserMoodle.username}}
                            </v-card-title>
                            <v-card-text>
                                <div>
                                    {{StateFoundUserMoodle.firstname}} {{StateFoundUserMoodle.lastname}}
                                </div>
                                <div class="text-disabled">
                                    {{StateFoundUserMoodle.email}}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <confirm-gdb @confirm="onConfirmResetPassword($event, StateFoundUserMoodle.username)"
                                    title="Redefinição de senha UNDB Classroom"
                                    header="Redefinição de senha"
                                    :message="`Confirma a redefinição de nova senha <b>undb@class</b> para usuário <b>${StateFoundUserMoodle.username} ${StateFoundUserMoodle.firstname} ${StateFoundUserMoodle.lastname}</b> na plataforma UNDB Classroom?`">
                                    <template v-slot:buttonaction>
                                        <v-btn :loading="StateFoundUserMoodleLoading">
                                            <v-icon>mdi-lock-reset</v-icon> <span class="ml-1">Redefinir Senha</span>
                                        </v-btn>
                                    </template>
                                </confirm-gdb>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    data:()=>({
        username:''
    }),
    mounted(){
    },
    methods:{
        ...mapActions(['FindUserMoodleUNDB', 'ResetPasswordMoodleUNDB']),
        onConfirmResetPassword(confirm, username){
            if(confirm){
                this.ResetPasswordMoodleUNDB({username})
            }
        }
    },
    computed:{
        ...mapGetters(['StateDark', 'StateFoundUserMoodle']),
        ...mapGetters(['StateResetPasswordMoodleUNDBLoading', 'StateFoundUserMoodleLoading'])
    },
    watch:{
    }
}
</script>